export default __webpack_public_path__ + "static/media/minus_icon.f3b682ce.svg";